import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Accordion, Text, useBreakpoint } from '@hh.ru/magritte-ui';

const TrlKeys = {
    title: 'career-platform.widgets.careerTrack.accordion.title',
    description: 'career-platform.widgets.careerTrack.accordion.description',
};

const AccordionCareerTrack: TranslatedComponent = ({ trls }) => {
    const { isXS, isS } = useBreakpoint();
    const isMobile = isXS || isS;
    return (
        <Accordion
            borderRadius={isMobile ? 16 : 24}
            padding={isMobile ? 16 : 24}
            title={<Text typography="subtitle-1-semibold">{trls[TrlKeys.title]}</Text>}
        >
            <Text typography="paragraph-3-regular">{trls[TrlKeys.description]}</Text>
        </Accordion>
    );
};

export default translation(AccordionCareerTrack);
